/**
 * Карточка элемента в настройках (правило, условный промпт и т.п.).
 * Единообразная структура: заголовок + кнопка удаления, тело.
 */
import React from 'react'
import { DeleteButton } from '../ui'

export default function SettingsItemCard({ label, onDelete, deleteTitle, children, className = '' }) {
  return (
    <div className={`settings-item-card ${className}`.trim()}>
      <div className="settings-item-card-header">
        <span className="settings-item-card-label">{label}</span>
        {typeof onDelete === 'function' && (
          <DeleteButton onClick={onDelete} title={deleteTitle} />
        )}
      </div>
      {children != null && <div className="settings-item-card-body">{children}</div>}
    </div>
  )
}
